<script>
  import { onMount } from "svelte";
  import { Link } from "../router";
  import CookieConsent from "../component/CookieConsent.svelte";
  import Header from "../component/Header.svelte";
  import Copyright from "../component/Copyright.svelte";

  onMount(() => {
    console.log("mount", "pricing");
  });
</script>

<main>
  <CookieConsent />
  <Header />

  <nav>
    <Link to="/">Home</Link>
    <Link to="/help">Help</Link>
  </nav>
  <div>TODO Nos offres</div>

  <Copyright company="KiwisApp" />
</main>
